// 'src/comps/feature.tsx'
import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

interface FeatureProps {
    title: string;
    description: string;
    featuresVisible: boolean;
    delay?: number;
    size: number;
    src: string;
}

export default function Feature({title, description, featuresVisible, size, delay = 150, src}: FeatureProps) {
    const colSpan =
        size === 2 ? "col-span-2" : size === 3 ? "md:col-span-3" : "col-span-1";

    const baseCard =
        `bg-white rounded-xl shadow-lg border border-gray-200 ` +
        `transform transition-all duration-700 ease-out ${colSpan} h-full min-h-[220px] ` +
        (featuresVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6");

    if (size === 2) {
        // Split layout: text left (bottom-left aligned), animation right
        return (
            <div
                className={`${baseCard} p-6 flex flex-row gap-6 items-stretch`}
                style={{ transitionDelay: featuresVisible ? `${delay}ms` : "0ms" }}
            >
                <div className="flex-1 flex flex-col justify-end items-start text-left">
                    <h3 className="text-xl font-bold">{title}</h3>
                    <p className="text-gray-600">{description}</p>
                </div>
                <div className="flex-1 flex items-center justify-center">
                    <DotLottieReact src={src} loop autoplay />
                </div>
            </div>
        );
    }

    // Default layout: animation as background overlay, text bottom-left
    return (
        <div
            className={`${baseCard} relative p-6 pt-40 flex flex-col justify-end items-start text-left`}
            style={{ transitionDelay: featuresVisible ? `${delay}ms` : "0ms" }}
        >
            <div className="absolute w-3/4 h-3/4 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-start justify-center -z-10 opacity-90">
                <DotLottieReact src={src} loop autoplay />
            </div>
            <h3 className="text-xl font-bold">{title}</h3>
            <p className="text-gray-600">{description}</p>
        </div>
    );
}
